import { functions } from "common/config/Firebase";
import createPDFTicketUseCase from "./createPDFTicket";
import findClientByTask from "tasks/services/sign/findClientByTask";

const sendTicketByEmailUseCase = async (ticketData, options = {}) => {
  const { extraText = "" } = options;

  // 1. Buscar datos del cliente para obtener el email
  let clientData = null;

  if (ticketData.dniClient) {
    clientData = await findClientByTask(ticketData.dniClient);
  }

  const to = clientData?.mail;
  if (!to) {
    throw new Error("Este cliente no tiene email configurado");
  }

  // 2. Generar + subir el PDF del ticket y obtener la URL
  const pdfUrl = await createPDFTicketUseCase({
    ticketData,
    initialTicketDetailData: null,
    operation: "uploadEmail",
    numberPhone: null,
    extraText,
  });

  // 3. Preparar llamada a la Cloud Function sendDocumentEmail
  const sendDocumentEmail = functions.httpsCallable("sendDocumentEmail");

  const safeName = (clientData?.name || "CLIENTE").trim().replace(/ /g, "_");
  const numTicketStr = String(ticketData.numTicket || "").padStart(5, "0");
  const filename = `${safeName}-TICKET-${numTicketStr}.pdf`;

  const formatDate = (value) => {
    if (!value) return "";
    if (typeof value === "number") return new Date(value).toLocaleDateString("es-ES");
    if (typeof value === "object" && value.seconds) return new Date(value.seconds * 1000).toLocaleDateString("es-ES");
    return String(value);
  };

  const formatMoney = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    if (Number.isNaN(n)) return String(value);
    return `${n.toFixed(2).replace(".", ",")} €`;
  };

  // Meta que usará la plantilla de "ticket" para pintar el correo
  const payload = {
    to,
    pdfUrl,
    filename,
    type: "ticket",
    meta: {
      ticketNumber: ticketData.numTicket,
      repairNumber: ticketData.taskReference,
      ticketDate: formatDate(ticketData.ticketDate),
      totalPrice: formatMoney(ticketData.totalPrice),
    },
  };

  const result = await sendDocumentEmail(payload);
  return result;
};

export default sendTicketByEmailUseCase;